import Swal from "sweetalert2";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import { get_token, get_user_details } from "@/router";
import { get_single_file_from_event } from "@/views/home/home_helper.js";
import {
  assessment_tool_methods,
  count_documents,
  count_folders,
  extract_year,
  get_latest_folder_id,
} from "@/views/AssessmentTools/assessment_tools_helper.js";

export default {
  name: "AssessmentToolsView",
  components: {
    HomeNavBar,
  },
  data: () => ({
      loading: false,
      is_uploading: false,
      is_dragging: false,
      folders: [],
      current_folders: [],
      current_files: [],
      folder_stack: [],
      search_query: "",
      active_tab: "indexes",
      token_exists: false,
      user_details: {
        user_role: "",
      },
      is_sidebar_open: false,
      selected_year_id: null,
      folder_name: "",
      validation_error: "",
      selected_upload_folder_id: "",
      upload_target_error: "",
      pending_upload_file: null,
      preview_url: null,
      preview_type: null,
      loading_preview: false,
      preview_key: 0,
      manage_mode: false,
      editing_item_type: "",
      editing_item: null,
      editing_item_name: "",
      edit_validation_error: "",
    }),
  computed: {
    year_folders() {
      return this.folders
        .filter((folder) => /\b(19|20)\d{2}\b/.test(folder.folder_name))
        .sort((a, b) => extract_year(b.folder_name) - extract_year(a.folder_name));
    },
    archive_folders() {
      return this.folders.filter((folder) => !/\b(19|20)\d{2}\b/.test(folder.folder_name));
    },
    display_folders() {
      const needle = this.search_query.toLowerCase();
      const base_folders = this.folder_stack.length ? this.current_folders : this.folders;

      if (!needle) {
        return base_folders;
      }

      return base_folders.filter((folder) => (folder.folder_name || "").toLowerCase().includes(needle));
    },
    display_files() {
      const needle = this.search_query.toLowerCase();

      if (!needle) {
        return this.current_files;
      }

      return this.current_files.filter((file) => this.get_file_name(file).toLowerCase().includes(needle));
    },
    total_document_count() {
      return count_documents(this.folders);
    },
    total_folder_count() {
      return count_folders(this.folders);
    },
    latest_year_label() {
      return this.year_folders.length ? extract_year(this.year_folders[0].folder_name) : "2024";
    },
    latest_folder_id() {
      return get_latest_folder_id(this.folders);
    },
    dimension_count() {
      return this.folders.length || 0;
    },
  },
  mounted() {
    this.token_exists = !!get_token();
    this.user_details = get_user_details() || { user_role: "" };
    this.fetch_assessment_folders();
    $("#assessment_preview_modal").on("hidden.bs.modal", this.close_preview);
  },
  beforeUnmount() {
    $("#assessment_preview_modal").off("hidden.bs.modal", this.close_preview);
  },
  methods: {
    ...assessment_tool_methods,
    get_token_value() {
      return get_token();
    },
    fetch_assessment_folders() {
      this.loading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_information/`,
        method: "GET",
        headers: {
              "Content-Type": "application/json",
        },
        success: (response) => {
          const remote_folders = Array.isArray(response?.data) ? response.data : [];
          this.folders = remote_folders;
          this.current_folders = this.folders;
          this.current_files = [];
          this.selected_year_id = null;
        },
        error: () => {
          this.folders = [];
          this.current_folders = this.folders;
          this.current_files = [];
          this.selected_year_id = null;
        },
        complete: () => {
          this.loading = false;
        },
      });
    },
    focus_search() {
      this.$refs.searchInput?.focus();
    },
    show_overview_coming_soon() {
      this.active_tab = "overview";
      this.folder_stack = [];
      this.current_folders = [];
      this.current_files = [];
      this.selected_year_id = null;
      this.close_sidebar();
    },
    show_indexes_tab() {
      this.active_tab = "indexes";
      this.go_root();
      this.close_sidebar();
    },
    toggle_sidebar() {
      this.is_sidebar_open = !this.is_sidebar_open;
    },
    close_sidebar() {
      this.is_sidebar_open = false;
    },
    open_create_year_modal() {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      this.folder_name = "";
      this.validation_error = "";
      $("#assessmentYearModal").modal("show");
    },
    handle_manage() {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      this.active_tab = "indexes";
      this.manage_mode = !this.manage_mode;
    },
    handle_add_document() {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      this.trigger_file_upload();
    },
    open_year_folder(folder) {
      this.active_tab = "indexes";
      this.selected_year_id = folder.id;
      this.folder_stack = [];
      this.open_folder(folder);
      this.close_sidebar();
    },
    open_folder(folder) {
      if (!this.folder_stack.length) {
        const root_folder = this.folders.find((item) => item.id === folder.id);
        this.selected_year_id = root_folder ? folder.id : this.selected_year_id;
      }

      const subfolders = Array.isArray(folder.subfolders) ? folder.subfolders : [];
      const files = Array.isArray(folder.files) ? folder.files : [];

      this.folder_stack.push({
        id: folder.id,
        folder_name: folder.folder_name,
        subfolders,
        files,
      });

      this.current_folders = subfolders;
      this.current_files = files;
    },
    go_back() {
      if (!this.folder_stack.length) {
        return;
      }

      this.folder_stack.pop();

      if (!this.folder_stack.length) {
        this.current_folders = this.folders;
        this.current_files = [];
        this.selected_year_id = null;
        return;
      }

      const parent_folder = this.folder_stack[this.folder_stack.length - 1];
      this.current_folders = parent_folder.subfolders || [];
      this.current_files = parent_folder.files || [];
    },
    go_root() {
      this.active_tab = "indexes";
      this.folder_stack = [];
      this.current_folders = this.folders;
      this.current_files = [];
      this.selected_year_id = null;
    },
    go_to_folder(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.folder_stack.length) {
        return;
      }

      this.folder_stack = this.folder_stack.slice(0, index + 1);
      const folder = Reflect.get(this.folder_stack, index);
      this.current_folders = folder?.subfolders || [];
      this.current_files = folder?.files || [];
    },
    create_folder() {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      this.validation_error = "";
      let created_successfully = false;

      if (!this.folder_name) {
        this.validation_error = "Index year name cannot be empty.";
        return;
      }

      const payload = {
        folder_name: this.folder_name,
        is_parent: true,
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_folder_api/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.get_token_value()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (data) => {
          if (data.status === "success") {
            created_successfully = true;
            const new_folder = {
              id: data.folder_data.id,
              folder_name: data.folder_data.folder_name || this.folder_name,
              date_created: data.folder_data.date_created,
              subfolders: data.folder_data.subfolders || [],
              files: data.folder_data.files || [],
            };

            this.folders.unshift(new_folder);
            this.current_folders = this.folders;
            this.selected_year_id = null;
            this.folder_name = "";

            Swal.fire({
              toast: true,
              position: "bottom-end",
              icon: "success",
              title: "Index year created",
              text: "The new folder has been added to your indexes list.",
              showConfirmButton: false,
              timer: 1200,
            });
          }
        },
        error: (xhr) => {
          this.validation_error = xhr.responseJSON?.message || "Unable to create the index year.";
        },
        complete: () => {
          if (created_successfully) {
            $("#assessmentYearModal").modal("hide");
          }
        },
      });
    },
    open_edit_item_modal(type, item) {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      this.editing_item_type = type;
      this.editing_item = item;
      this.editing_item_name = type === "folder" ? item.folder_name : this.get_file_name(item);
      this.edit_validation_error = "";
      $("#assessmentEditItemModal").modal("show");
    },
    save_item_edit() {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      this.edit_validation_error = "";

      if (!this.editing_item_name.trim()) {
        this.edit_validation_error = "Name cannot be empty.";
        return;
      }

      if (this.editing_item_type === "folder") {
        this.update_folder();
        return;
      }

      if (this.editing_item_type === "file") {
        this.update_file();
      }
    },
    update_folder() {
      if (!this.editing_item) {
        return;
      }

      const payload = {
        folder_id: this.editing_item.id,
        folder_name: this.editing_item_name.trim(),
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/edit_folder_api/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.get_token_value()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            const updated_folder = response.folder_data || {
              ...this.editing_item,
              folder_name: payload.folder_name,
            };
            this.update_folder_in_tree(this.folders, updated_folder);
            this.update_folder_in_stack(updated_folder);
            $("#assessmentEditItemModal").modal("hide");
            this.show_toast("success", "Folder updated", "The folder name was updated.");
          }
        },
        error: (xhr) => {
          this.edit_validation_error = xhr.responseJSON?.message || "Unable to update this folder.";
        },
      });
    },
    update_file() {
      if (!this.editing_item) {
        return;
      }

      const payload = {
        folder_document_id: this.editing_item.id,
        file_name: this.editing_item_name.trim(),
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/edit_folder_document/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.get_token_value()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            const updated_file = {
              ...this.editing_item,
              ...(response.folder_document_data || {}),
              file: {
                ...(this.editing_item.file || {}),
                ...(response.folder_document_data?.file || {}),
                name: payload.file_name,
              },
            };
            this.update_file_in_current_folder(updated_file);
            $("#assessmentEditItemModal").modal("hide");
            this.show_toast("success", "File updated", "The file name was updated.");
          }
        },
        error: (xhr) => {
          this.edit_validation_error = xhr.responseJSON?.message || "Unable to update this file.";
        },
      });
    },
    delete_folder(folder) {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }

      Swal.fire({
        title: "Delete folder?",
        text: "This cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        position: "bottom-end",
        toast: true,
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_folder/`,
          method: "POST",
          headers: {
            Authorization: `Token ${this.get_token_value()}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify({ folder_id: folder.id }),
          success: (response) => {
            if (response.status === "success") {
              this.remove_folder_from_tree(this.folders, folder.id);
              this.remove_folder_from_stack(folder.id);
              this.current_folders = this.folder_stack.length
                ? this.folder_stack[this.folder_stack.length - 1].subfolders || []
                : this.folders;
              this.show_toast("success", "Folder deleted", "The folder was removed.");
            }
          },
          error: (xhr) => {
            this.show_toast("error", "Delete failed", xhr.responseJSON?.message || "Unable to delete this folder.");
          },
        });
      });
    },
    delete_file(file) {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }

      Swal.fire({
        title: "Delete file?",
        text: "This cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        position: "bottom-end",
        toast: true,
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_folder_document/`,
          method: "DELETE",
          headers: {
            Authorization: `Token ${this.get_token_value()}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify({ folder_document_id: file.id }),
          success: (response) => {
            if (response.status === "success") {
              this.remove_file_from_current_folder(file.id);
              this.show_toast("success", "File deleted", "The file was removed.");
            }
          },
          error: (xhr) => {
            this.show_toast("error", "Delete failed", xhr.responseJSON?.message || "Unable to delete this file.");
          },
        });
      });
    },
    show_toast(icon, title, text) {
      Swal.fire({
        toast: true,
        position: "bottom-end",
        icon,
        title,
        text,
        showConfirmButton: false,
        timer: 1400,
      });
    },
    trigger_file_upload() {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      if (this.is_uploading) {
        return;
      }
      this.$refs.warehouse_file?.click();
    },
    handle_drop(event) {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        this.is_dragging = false;
        return;
      }
      this.is_dragging = false;
      const files = event?.dataTransfer?.files;
      if (!files || !files.length) {
        return;
      }

      this.upload_selected_file(files[0]);
    },
    handle_file_upload(event) {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        this.clear_warehouse_file_input(event);
        return;
      }
      const file = get_single_file_from_event(event);
      if (!file) {
        return;
      }

      if (!this.folder_stack.length) {
        this.pending_upload_file = file;
        this.selected_upload_folder_id = this.year_folders[0]?.id || this.folders[0]?.id || "";
        this.upload_target_error = "";
        $("#assessmentUploadTargetModal").modal("show");
        return;
      }

      this.upload_selected_file(file);
    },
    confirm_root_upload() {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      if (!this.selected_upload_folder_id) {
        this.upload_target_error = "Please select an index year.";
        return;
      }

      const target_folder = this.folders.find((folder) => String(folder.id) === String(this.selected_upload_folder_id));
      if (!target_folder || !this.pending_upload_file) {
        this.upload_target_error = "Unable to continue this upload.";
        return;
      }

      this.upload_target_error = "";
      $("#assessmentUploadTargetModal").modal("hide");
      this.upload_selected_file(this.pending_upload_file, target_folder);
    },
    upload_selected_file(file, target_folder = null) {
      if (!(this.token_exists && this.user_details.user_role == "admin")) {
        return;
      }
      const current_folder = target_folder || this.folder_stack[this.folder_stack.length - 1];

      if (!current_folder) {
        Swal.fire({
          toast: true,
          position: "bottom-end",
          icon: "info",
          title: "Select an index year",
          text: "Choose an index year for this document.",
          showConfirmButton: false,
          timer: 1800,
        });
        this.clear_warehouse_file_input();
        return;
      }

      this.is_uploading = true;
      const form_data = new FormData();
      form_data.append("file", file);
      form_data.append("file_name", file.name);
      form_data.append("folder_id", current_folder.id);

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_folder_document_api/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.get_token_value()}`,
        },
        data: form_data,
        processData: false,
        contentType: false,
        success: (data) => {
          if (data.status === "success") {
            const new_file = {
              id: data.document_folder_data.id,
              file: {
                name: file.name,
                s3_url: data.document_folder_data.file.s3_url,
                date: data.document_folder_data.file.date,
              },
            };

            this.current_files.unshift(new_file);
            const active_folder = this.folder_stack[this.folder_stack.length - 1];
            if (active_folder) {
              active_folder.files = [new_file, ...(active_folder.files || [])];
            }

            const folder_in_root = this.folders.find((folder) => folder.id === current_folder.id);
            if (folder_in_root) {
              folder_in_root.files = [new_file, ...(folder_in_root.files || [])];
            }

            Swal.fire({
              toast: true,
              position: "bottom-end",
              icon: "success",
              title: "Document uploaded",
              text: "Your file was added to this index year.",
              showConfirmButton: false,
              timer: 1200,
            });
          }
        },
        error: (xhr) => {
          Swal.fire({
            toast: true,
            position: "bottom-end",
            icon: "error",
            title: "Upload failed",
            text: xhr.responseJSON?.message || "Unable to upload this document right now.",
            showConfirmButton: false,
            timer: 2200,
          });
        },
        complete: () => {
          this.is_uploading = false;
          this.is_dragging = false;
          this.pending_upload_file = null;
          this.selected_upload_folder_id = "";
          this.upload_target_error = "";
          this.clear_warehouse_file_input();
        },
      });
    },
  },
};
